<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <outage-status-banner
          :outage="activeOutage"
          :loading="loading.active"
          :deactivating="loading.deactivate"
          :warning-days="outageWarningDays"
          @deactivate="deactivateActiveOutage()"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="5">
        <outage-form
          ref="outageForm"
          :active-outage="activeOutage"
          :loading="loading.store"
          @publish="createNewOutage"
        />
      </v-col>

      <v-col cols="12" md="7">
        <outage-history-list
          :items="outagesHistory"
          :loading="loading.history"
          :toggling-id="loading.toggle"
          :warning-days="outageWarningDays"
          @activate="confirmActivateOutage"
          @deactivate="(item) => deactivateActiveOutage(item.id)"
        />
      </v-col>
    </v-row>

    <global-confirm-box ref="confirmBox" />
  </v-container>
</template>

<script>
import outageService from "@/services/outage";
import hasSnackbar from "@/mixins/hasSnackbar";
import OutageStatusBanner from "@/components/outages/OutageStatusBanner.vue";
import OutageForm from "@/components/outages/OutageForm.vue";
import OutageHistoryList from "@/components/outages/OutageHistoryList.vue";

export default {
  name: "OutageManager",
  mixins: [hasSnackbar],
  components: {
    OutageStatusBanner,
    OutageForm,
    OutageHistoryList,
  },
  data() {
    return {
      activeOutage: null,
      outagesHistory: [],
      outageWarningDays: 7,
      loading: {
        active: false,
        history: false,
        store: false,
        deactivate: false, // Loader za glavno dugme za gašenje
        toggle: null,
      },
    };
  },
  created() {
    this.getActiveOutage();
    this.getOutagesHistory();
  },
  methods: {
    getActiveOutage() {
      this.loading.active = true;
      outageService
        .getActiveOutage(this.$i18n.locale)
        .then((response) => {
          this.activeOutage = response.data;
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            this.activeOutage = null; // Znači da nema aktivne poruke
          } else {
            this.showErrorSnackbar(this.$t("error_loading_active_outage"));
          }
        })
        .finally(() => {
          this.loading.active = false;
        });
    },

    getOutagesHistory() {
      this.loading.history = true;
      outageService
        .getOutages(this.$i18n.locale)
        .then((response) => {
          this.outagesHistory = response.data;
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_loading_outage_history"));
        })
        .finally(() => {
          this.loading.history = false;
        });
    },

    createNewOutage(payload) {
      this.loading.store = true;
      outageService
        .createOutage(payload)
        .then(() => {
          this.showSuccessSnackbar(this.$t("outage_published_success"));
          if (this.$refs.outageForm) {
            this.$refs.outageForm.reset();
          }
          this.refreshData();
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_publishing_outage"));
        })
        .finally(() => {
          this.loading.store = false;
        });
    },

    confirmActivateOutage(item) {
      this.$refs.confirmBox
        .open(this.$t("are_you_sure"), this.$t("outage_activate_confirm_text"), {
          color: "primary",
        })
        .then(() => {
          this.activateOutage(item.id);
        })
        .catch(() => {});
    },

    activateOutage(id) {
      this.loading.toggle = id;
      outageService
        .activateOutage(id)
        .then(() => {
          this.showSuccessSnackbar(this.$t("outage_activated_success"));
          this.refreshData();
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_activating_outage"));
        })
        .finally(() => {
          this.loading.toggle = null;
        });
    },

    // NOVA METODA: Gasi sve poruke u bazi
    deactivateActiveOutage(itemId = null) {
      // Ako je kliknuto iz liste, stavljamo loader na taj red, inače na glavno dugme
      if (itemId) {
        this.loading.toggle = itemId;
      } else {
        this.loading.deactivate = true;
      }

      outageService
        .deactivateAllOutages()
        .then(() => {
          this.showSuccessSnackbar(this.$t("outage_deactivated_success"));
          this.refreshData();
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_deactivating_outage"));
        })
        .finally(() => {
          this.loading.deactivate = false;
          this.loading.toggle = null;
        });
    },

    // Pomoćna metoda za osvežavanje oba izvora podataka
    refreshData() {
      this.getActiveOutage();
      this.getOutagesHistory();
    },
  },
};
</script>
